/*
 * @Author: 刘欢
 * @LastEditors: 刘欢
 * @Date: 2024-03-12 20:11:57
 * @LastEditTime: 2024-03-12 20:11:57
 * @Description: 新增或编辑配方档案
 */

import type {
  IProductFormulaModel,
  IProductFormulaStore,
} from '@monorepo/types/goods/goodsFormula/goodsFormula.types';
import { tableUpdate } from '@monorepo/utils';

const initState: IProductFormulaStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
  },
  keyword: '',
  active_is: false,
  sort_order: '',
};

const GoodsFormulaStore: IProductFormulaModel = {
  namespace: 'goodsFormulaStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.storehouse_num);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default GoodsFormulaStore;
